export default __webpack_public_path__ + "static/media/logo_small_contact.3fc35b06.png";